import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pyl-dashboard',
  templateUrl: './pyl-dashboard.component.html',
  styleUrls: ['./pyl-dashboard.component.scss']
})
export class PylDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
